.sentimentGroup {
    height: 40px;
    width: 5px;
    border-radius: 5px;
    margin-right: 10px;
}
